<p
  class="current"
  (click)="toggleSelector($event)"
  (appClickOutside)="opened = false"
>
  <span class="name">{{ selected.name || selected.label | translate }}</span>
</p>
<div class="selector">
  <div class="header" *ngIf="title">
    <p>{{ title | translate }}</p>
  </div>
  <ul class="custom-scrollbar">
    <li
      *ngFor="let option of options"
      [class.selected]="isOptionSelected(option)"
      (click)="selectOption($event, option)"
    >
      {{ option.name || option.label | translate }}
    </li>
  </ul>
</div>
